import { Trash2 } from 'lucide-react';
import { colors } from '../../styles/colors';
import ModalPortal from '../ModalPortal';

/**
 * DeleteConfirmModal - Modale de confirmation de suppression réutilisable
 *
 * @param {boolean} isOpen - Afficher la modale
 * @param {Function} onClose - Callback de fermeture
 * @param {Function} onConfirm - Callback de confirmation
 * @param {boolean} loading - État de chargement
 * @param {string} title - Titre de la modale (défaut: "Confirmer la suppression")
 * @param {ReactNode} children - Contenu personnalisé du message
 */
function DeleteConfirmModal({
  isOpen,
  onClose,
  onConfirm,
  loading = false,
  title = 'Confirmer la suppression',
  children
}) {
  if (!isOpen) return null;

  return (
    <ModalPortal>
      <div style={overlayStyle}>
        <div style={modalStyle}>
          {/* Icône */}
          <div style={iconContainerStyle}>
            <Trash2 size={32} color="#dc2626" />
          </div>

          {/* Titre */}
          <h3 style={titleStyle}>{title}</h3>

          {/* Contenu personnalisé */}
          <div style={contentStyle}>
            {children}
          </div>

          {/* Boutons */}
          <div style={buttonsContainerStyle}>
            <button
              onClick={onClose}
              disabled={loading}
              style={cancelButtonStyle}
            >
              Annuler
            </button>
            <button
              onClick={onConfirm}
              disabled={loading}
              style={{
                ...deleteButtonStyle,
                cursor: loading ? 'wait' : 'pointer',
                opacity: loading ? 0.7 : 1
              }}
            >
              {loading ? 'Suppression...' : 'Supprimer'}
            </button>
          </div>
        </div>
      </div>
    </ModalPortal>
  );
}

// === STYLES ===

const overlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 1000
};

const modalStyle = {
  backgroundColor: colors.text.white,
  borderRadius: '1rem',
  padding: '2rem',
  maxWidth: '450px',
  width: '90%',
  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
  textAlign: 'center'
};

const iconContainerStyle = {
  width: '60px',
  height: '60px',
  borderRadius: '50%',
  backgroundColor: '#fee2e2',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  margin: '0 auto 1.5rem'
};

const titleStyle = {
  margin: '0 0 1rem 0',
  fontFamily: '"Century Gothic Bold", "Noto Sans", sans-serif',
  fontSize: '1.25rem',
  color: colors.primary.gray
};

const contentStyle = {
  margin: '0 0 1.5rem 0',
  fontFamily: '"Noto Sans", sans-serif',
  fontSize: '0.9375rem',
  color: colors.primary.gray,
  lineHeight: '1.5'
};

const buttonsContainerStyle = {
  display: 'flex',
  gap: '1rem',
  justifyContent: 'center'
};

const cancelButtonStyle = {
  padding: '0.75rem 1.5rem',
  borderRadius: '0.5rem',
  border: `2px solid ${colors.secondary.mediumGray}`,
  backgroundColor: 'transparent',
  color: colors.primary.gray,
  fontSize: '1rem',
  fontWeight: '600',
  fontFamily: '"Noto Sans", sans-serif',
  cursor: 'pointer'
};

const deleteButtonStyle = {
  padding: '0.75rem 1.5rem',
  borderRadius: '0.5rem',
  border: 'none',
  backgroundColor: '#dc2626',
  color: colors.text.white,
  fontSize: '1rem',
  fontWeight: '600',
  fontFamily: '"Noto Sans", sans-serif'
};

export default DeleteConfirmModal;
